'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("$httpErrorHandler", function ($rootScope, $modal, $dialogBox) {
  var popinScope = $rootScope.$new(),
    popinOpened = false;
  var errorHandler = {
    handleServerError: function handleServerError(error) {
      var statusCode = error.httpCode || error.statusCode || 500;
      if (statusCode === 403 || statusCode === 0) {
        // 0 -> canceled requests
        return;
      }
      if (statusCode === 401) {
        errorHandler.handlerUnauthorized(error);
      } else {
        errorHandler.handleError(error);
      }
    },
    handleError: function handleError(error) {
      if (popinOpened) {
        return;
      }
      popinOpened = true;
      if (error.statusCode === 401) {
        return this.handlerUnauthorized(error);
      }
      popinScope.error = error;
      $modal.open({
        template: require("./errorPopin.html"),
        controller: ["$scope", function ($scope) {
          $scope.showDetails = false;
          $scope.toggleDetails = function () {
            $scope.showDetails = !$scope.showDetails;
          };
        }],
        scope: popinScope,
        options: {
          width: 700
        }
      }).then(function () {
        popinOpened = false;
      });
    },
    handlerUnauthorized: function handlerUnauthorized(unauthorizedError) {
      var cause = unauthorizedError.errorId;
      if (popinOpened) {
        return;
      }
      popinOpened = true;
      if (cause === "NOT_LOGGED") {
        var authentificationUrl = "https://www.taelys.com";
        window.location.href = authentificationUrl + "?errorMsg=session.timeout&target=" + window.location.href;
      } else if (cause === "ROLE_NOT_ALLOWED") {
        $dialogBox.alert({
          title: "Action interdite",
          text: "Vous ne disposez pas des droits necessaires pour effectuer cette action. " + "Si vous pensez que cela est une erreur, veuillez contacter votre consultant."
        }).then(function () {
          popinOpened = false;
        });
      }
    }
  };
  return errorHandler;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/error/httpErrorHandler.js
// module id = 2697
// module chunks = 13